import { render, staticRenderFns } from "./Current_bonus.vue?vue&type=template&id=166fecd8&scoped=true&"
import script from "./Current_bonus.vue?vue&type=script&lang=js&"
export * from "./Current_bonus.vue?vue&type=script&lang=js&"
import style0 from "./Current_bonus.vue?vue&type=style&index=0&id=166fecd8&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "166fecd8",
  null
  
)

export default component.exports